<template>
  <div class="fc">
    <div class="xxqk">
      <h3 class="xxqk_tit">签到情况</h3>
      <h1 class="xxqk_dur">课程有效时长：{{this.signInfo.duration}}</h1>
      <img
        src="../../assets/close.png"
        class="xxqk_close"
        alt=""
        @click="$emit('closeLayer')"
      />
      <div class="xxqk_table">
        <div class="xxqk_tabltTop flex">
          <div class="xxqk_td">课程小节名称</div>
          <div class="xxqk_td flex_item">签到情况</div>
          <div class="xxqk_td flex_item">签退情况</div>
        </div>
        <div
          v-for="(info, index) of this.signInfo.infos"
          :key="index"
          class="xxqk_tabltBody flex"
        >
          <div class="xxqk_td">
            <span>{{info.scheduleName}}</span>
          </div>
          <div class="xxqk_td flex_item">
              <span :class="info.signInStatus == '已签到' ? 'greenStatus' : 'redStatus'"> {{info.signInStatus}} </span>
          </div>
          <div class="xxqk_td flex_item">
              <span :class="info.signOutStatus == '已签退' ? 'greenStatus' : 'redStatus'"> {{info.signOutStatus}} </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    signInfo: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.fc {
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: block;
}

.xxqk {
  padding: 60px 0px;
  padding-top: 32px;
  position: relative;
  background-color: #fff;
  border-radius: 8rpx;
  margin: 0 auto;
  margin-top: 235px;
  width: 900px;
  box-sizing: border-box;
}

.xxqk_tit {
  font-size: 28px;
  font-weight: 600;
  color: #222;
  line-height: 40px;
  text-align: center;
}
.xxqk_dur {
  font-size: 20px;
  font-weight: 600;
  color: #222;
  line-height: 40px;
  text-align: center;
}

.xxqk_close {
  width: 24px;
  height: 24px;
  position: absolute;
  top: 32px;
  right: 40px;
  cursor: pointer;
}

.xxqk_table {
  margin-top: 32px;
  margin-left: 60px;
  margin-right: 60px;
}

.xxqk_tabltTop {
  background-color: #e1e6eb;
  color: #222222;
  font-size: 16px;
  font-weight: 400;
  line-height: 74px;
  height: 74px;
}

.xxqk_td:first-child {
  width: 360px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}

.xxqk_td {
  text-align: center;
}

/* .xxqk_content {
  font-size: 16px;
  color: #222;
  font-weight: 400;
  margin-right: 10px;
} */

.xxqk_time {
  font-size: 16px;
  color: #222;
  font-weight: 400;
  margin-right: 10px;
}


.xxqk_table {
  border-bottom: 1px solid #e1e6eb;
}

.xxqk_tabltBody {
  border-left: 1px solid #e1e6eb;
}

.xxqk_tabltBody .xxqk_td {
  border-right: 1px solid #e1e6eb;
  border-top: 1px solid #e1e6eb;
  height: 72px;
  line-height: 72px;
}

.xgw {
  font-size: 14px;
  color: #fff;
  width: 70px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  display: inline-block;
  background-color: #003399;
  cursor: pointer;
}
.greenStatus {
    color: #1eb521
}
.redStatus {
   
    color: #fa4444
}

.flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.flex_item {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  min-width: 0;
}

</style>